var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import css2json from 'css2json';
import { chain, cloneDeep } from 'lodash';
import * as React from 'react';
import AceEditor from 'react-ace';
import tidify from 'tidify';
import 'brace/ext/language_tools';
import 'brace/mode/css';
import 'brace/mode/json';
import 'brace/theme/monokai';
import { convertObjectToCss } from '../../util-components/zone-layout';
import { Styled } from './style';
export var LanguageMode;
(function (LanguageMode) {
    LanguageMode["CSS"] = "css";
    LanguageMode["JSON"] = "json";
})(LanguageMode || (LanguageMode = {}));
// for more rules: https://github.com/CSSLint/csslint/wiki/rules
var INFO_RULES = [];
var DISABLED_RULES = [
    'order-alphabetical',
    'ids',
    'zero-units',
];
var CodeEditor = /** @class */ (function (_super) {
    __extends(CodeEditor, _super);
    function CodeEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnBlur = function () {
            if (_this.props.language === 'css' && _this.props.onBlur) {
                var styleData = css2json(_this.state.code);
                var styleObject = cloneDeep(styleData);
                var formattedStyleObj = chain(styleObject)
                    .toPairs()
                    .map(function (_a) {
                    var key = _a[0], value = _a[1];
                    if (value.top === '0%') {
                        value.top = '0';
                    }
                    if (value.bottom === '0%') {
                        value.bottom = '0';
                    }
                    if (value.left === '0%') {
                        value.left = '0';
                    }
                    if (value.right === '0%') {
                        value.right = '0';
                    }
                    return [key, value];
                })
                    .fromPairs()
                    .value();
                var cssStyled = tidify(convertObjectToCss(formattedStyleObj));
                _this.props.onBlur(cssStyled);
            }
        };
        _this.onEditSessionInit = function (editSession) {
            if (_this.props.language === LanguageMode.CSS) {
                editSession.$worker.call('setInfoRules', [INFO_RULES.join('|')]);
                editSession.$worker.call('setDisabledRules', [DISABLED_RULES.join('|')]);
            }
        };
        _this.state = {
            annotations: [],
            code: _this.props.value,
        };
        return _this;
    }
    CodeEditor.prototype.handleChange = function (value) {
        this.setState({ code: value });
        this.props.onChange(value);
    };
    CodeEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(Styled, { className: this.props.className },
            React.createElement(AceEditor, { placeholder: "Custom Your " + (this.props.language === 'css' ? 'Stylesheet' : 'Object'), mode: this.props.language, theme: "monokai", onChange: function (code) { return _this.handleChange(code); }, fontSize: 14, onLoad: function (editor) {
                    _this.onEditSessionInit(editor.session);
                }, onBlur: this.handleOnBlur, showPrintMargin: false, showGutter: true, highlightActiveLine: true, value: this.state.code, height: this.props.height, width: this.props.width, editorProps: { $blockScrolling: true }, setOptions: {
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: true,
                    tabSize: 2,
                } })));
    };
    return CodeEditor;
}(React.Component));
export default CodeEditor;
//# sourceMappingURL=index.js.map